/**
 * The franchise a dashboard request acts for (`x-on-behalf-of-franchise`): a merchant's
 * selected franchise, else the selected restaurant's. Shared by the API client and by
 * views that key cached lists on that scope, so the two never disagree.
 */
export function onBehalfOfFranchiseId({ isMerchant, currentFranchiseId, company }) {
  return (isMerchant ? (currentFranchiseId ?? company?.franchise_id) : company?.franchise_id) ?? null;
}
